module.exports = __webpack_public_path__ + "img/tr-driver-overlap-icon.f76356fc.svg";